var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    {
      staticClass: "default feedback-element-update",
      on: {
        submit: function submit($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$gettext("Feedback-Element bearbeiten")))]),
      _vm._v(" "),
      _c("label", [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Frage")) + "\n        "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentQuestion,
              expression: "currentQuestion",
            },
          ],
          attrs: {
            type: "text",
          },
          domProps: {
            value: _vm.currentQuestion,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.currentQuestion = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "\n        " + _vm._s(_vm.$gettext("Beschreibung")) + "\n        "
        ),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentDescription,
              expression: "currentDescription",
            },
          ],
          domProps: {
            value: _vm.currentDescription,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.currentDescription = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "button-wrapper",
        },
        [
          _c(
            "button",
            {
              staticClass: "button accept",
              on: {
                click: _vm.submitUpdate,
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Absenden")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button cancel",
              on: {
                click: function click($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Abbrechen")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }